import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user === undefined) return <div className="min-h-screen bg-[color:var(--bg)]" />;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen bg-[color:var(--bg)] text-[color:var(--text)] flex items-center justify-center px-5 grain">
      <div className="w-full max-w-md">
        <Link to="/" className="eyebrow link-underline">← Back to site</Link>
        <h1 className="mt-8 font-display italic text-5xl md:text-6xl leading-[0.95] tracking-tight">Admin</h1>
        <p className="mt-3 text-[color:var(--text-muted)]">Sign in to manage the portfolio.</p>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="eyebrow block mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border border-[color:var(--border)] focus:border-[color:var(--accent)] outline-none px-4 py-3 text-[color:var(--text)]"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border border-[color:var(--border)] focus:border-[color:var(--accent)] outline-none px-4 py-3 text-[color:var(--text)]"
            />
          </div>
          {error && <div data-testid="login-error" className="text-red-400 text-sm">{error}</div>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="btn-pill btn-primary w-full justify-center"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
